<template lang="pug">
section
  s-page-title(title='Акции')
  v-card
    s-data-filter(@search='debouncedSearch' :initial='dataFilter.search')
      template(slot='controls')
        v-layout
          v-flex(xs12)
            s-action-status-picker(
              :value='dataFilter.status'
              @change='setStatus'
            )
          v-flex(xs12)
            s-partner-picker(
              :returnObject='false'
              :value='dataFilter.organization_id'
              @change='setOrgId'
            )
    v-data-table(
      :loading='isLoading'
      :headers='headers'
      :items='list'
      :total-items='total'
      :pagination='dataFilter'
      :rows-per-page-items='$config.rowsPerPageItems'
      @update:pagination='updatePagination'
    )
      template(slot='items' slot-scope='props')
        tr(class='with-pointer' @click='selectAction(props.item.id)')
          td(data-label='#ID') {{ props.item.id }}
          td(data-label='Название') 
            div {{ props.item.name }}
            div(class="descrition") {{ props.item.description }}
          td(data-label='Время начала') {{ props.item.start_time | date }}
          td(data-label='Время завершения') {{ props.item.stop_time | date }}
          td(data-label='Статус') {{ props.item.status_name }}
</template>

<script>
import { debounce } from 'lodash'
import { mapActions, mapState, mapGetters, mapMutations } from 'vuex'

export default {
  data: () => ({
    headers: [
      {
        text: '#ID',
        align: 'left',
        value: 'id',
        width: '5%'
      },
      {
        text: 'Название',
        align: 'left',
        value: 'name',
        width: '40%'
      },
      {
        text: 'Дата начала',
        align: 'left',
        value: 'start_time',
        width: '10%'
      },
      {
        text: 'Дата завершения',
        align: 'left',
        value: 'stop_time',
        width: '10%'
      },
      {
        text: 'Статус',
        align: 'left',
        value: 'status',
        width: '10%'
      }
    ]
  }),

  methods: {
    updatePagination(pagination) {
      this.setDataFilter(pagination)
      this.fetch()
    },

    setStatus(status = null) {
      this.setDataFilter({ status })
      this.fetch()
    },

    setOrgId(organization_id = null) {
      this.setDataFilter({ organization_id })
      this.fetch()
    },

    selectAction(id) {
      this.$router.push({
        name: 'Partners.Actions.Show',
        params: { id }
      })
    },

    fetch() {
      this.fetchList({ config: { params: this.dataFilter } })
    },

    debouncedSearch: debounce(function(search) {
      this.setDataFilter({ search, page: 1 })
      this.fetch()
    }, 250),

    ...mapActions('partners/actions', ['fetchList', 'destroy']),
    ...mapMutations('partners/actions', ['setDataFilter'])
  },

  computed: {
    ...mapState('partners/actions', ['total', 'dataFilter']),
    ...mapGetters('partners/actions', ['list', 'isLoading'])
  }
}
</script>

<style scoped>
.descrition {
  margin-top: 10px;
  font-size: 10px;
  color: gray;
}
</style>
